/**
 * Point d'entrée React pour UNIQUE.
 * Monte l'application dans #root, active StrictMode, importe la charte globale.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('UNIQUE: élément racine #root introuvable dans index.html');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
